import React from 'react';
import { Card, CardActions, CardContent, CardMedia, Typography, Button } from '@mui/material';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import './About.css'

const About = () => {
    return (
        <div>
            <Card sx={{ minWidth: 275 }}>
                <CardContent>
                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                        We are here for you to teach you with fun!!
                    </Typography>
                    <Typography variant="h5" component="div">
                        Learn With Fun
                    </Typography>
                    <Typography sx={{ mb: 1.5 }} color="text.secondary">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel rerum similique nihil optio, voluptatem odit explicabo aperiam minus pariatur eum obcaecati, placeat libero laudantium aliquam modi! Itaque earum eos sapiente reiciendis et, praesentium ullam debitis ducimus reprehenderit, numquam mollitia.
                    </Typography>
                    <Typography variant="body2">
                        <br />
                    </Typography>
                </CardContent>
                <CardActions>
                    <Button size="small">Learn More</Button>
                </CardActions>
            </Card>
        </div>
    );
};

export default About;